import {
  GET_AGENT_REQUEST_GENERATE_OTP_FOR_CHANGE_AVA,
  GET_AGENT_REQUEST_NUM_AVA,
  GET_AGENT_REQUEST_NUM_NEXT_VALUE,
  GET_AGENT_REQUEST_PAYMENT_PLAN,
  GET_AGENT_REQUEST_PERSONAL_INFO_DETAILS,
  GET_AGENT_REQUEST_PERSONAL_INFO_LIST,
  GET_AGENT_REQUEST_VALIDATE_CHANGE_AVA,
  GET_AGENT_REQUEST_VALIDATE_CHANGE_PERSONAL_INFO,
  GET_AGENT_REQUEST_VALIDATE_OTP,
  GET_E_CARD_AVATAR,
  GET_E_CARD_INFO,
  GET_E_CARD_PERSONAL_BUSINESS_INFO,
  GET_E_CARD_QR_IMAGE,
  GET_INFO_REQUEST_FORM,
  GET_REFRESH_OTP,
  SET_AGENT_REQUEST_PAYMENT_PLAN,
  SET_AGENT_REQUEST_PERSONAL_INFO_DETAILS,
  SET_AGENT_REQUEST_PERSONAL_INFO_LIST,
  SET_E_CARD_AVATAR,
  SET_E_CARD_INFO,
  SET_E_CARD_PERSONAL_BUSINESS_INFO,
  SET_E_CARD_QR_IMAGE,
} from '@stores/myprofile/constants.js';

export const getECardInfo = (payload) => ({
  type: GET_E_CARD_INFO,
  payload,
});

export const setECardInfo = (payload) => ({
  type: SET_E_CARD_INFO,
  payload,
});

export const getECardPersonalBusinessInfo = (payload) => ({
  type: GET_E_CARD_PERSONAL_BUSINESS_INFO,
  payload,
});

export const setECardPersonalBusinessInfo = (payload) => ({
  type: SET_E_CARD_PERSONAL_BUSINESS_INFO,
  payload,
});

export const getECardAva = (payload) => ({
  type: GET_E_CARD_AVATAR,
  payload,
});

export const setECardAva = (payload) => ({
  type: SET_E_CARD_AVATAR,
  payload,
});

export const getECardQrImage = (payload) => ({
  type: GET_E_CARD_QR_IMAGE,
  payload,
});

export const setECardQrImage = (payload) => ({
  type: SET_E_CARD_QR_IMAGE,
  payload,
});

export const getAgentRequestValidateChangeAva = (payload, callback) => ({
  type: GET_AGENT_REQUEST_VALIDATE_CHANGE_AVA,
  payload,
  callback,
});

export const getAgentRequestGenerateOTPForChangeAva = (payload, callback) => ({
  type: GET_AGENT_REQUEST_GENERATE_OTP_FOR_CHANGE_AVA,
  payload,
  callback,
});

export const getRefreshOtp = (payload, callback) => ({
  type: GET_REFRESH_OTP,
  payload,
  callback,
});

export const getAgentRequestValidateOTP = (payload, callback) => ({
  type: GET_AGENT_REQUEST_VALIDATE_OTP,
  payload,
  callback,
});

export const getAgentRequestNumAva = (payload, callback) => ({
  type: GET_AGENT_REQUEST_NUM_AVA,
  payload,
  callback,
});

export const getAgentRequestPersonalInfoList = (payload) => ({
  type: GET_AGENT_REQUEST_PERSONAL_INFO_LIST,
  payload,
});

export const setAgentRequestPersonalInfoList = (payload) => ({
  type: SET_AGENT_REQUEST_PERSONAL_INFO_LIST,
  payload,
});

export const getAgentRequestPersonalInfoDetails = (payload) => ({
  type: GET_AGENT_REQUEST_PERSONAL_INFO_DETAILS,
  payload,
});

export const setAgentRequestPersonalInfoDetails = (payload) => ({
  type: SET_AGENT_REQUEST_PERSONAL_INFO_DETAILS,
  payload,
});

export const getAgentRequestPaymentPlan = (payload) => ({
  type: GET_AGENT_REQUEST_PAYMENT_PLAN,
  payload,
});

export const setAgentRequestPaymentPlan = (payload) => ({
  type: SET_AGENT_REQUEST_PAYMENT_PLAN,
  payload,
});

export const getAgentRequestValidateChangePersonalInfo = (
  payload,
  callback,
) => ({
  type: GET_AGENT_REQUEST_VALIDATE_CHANGE_PERSONAL_INFO,
  payload,
  callback,
});

export const getAgentRequestNumNextValue = (payload, callback) => ({
  type: GET_AGENT_REQUEST_NUM_NEXT_VALUE,
  payload,
  callback,
});

export const getInfoRequestForm = (payload, callback) => ({
  type: GET_INFO_REQUEST_FORM,
  payload,
  callback,
});
